import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Check",
  "use": "Check-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Check\"><path fill-rule=\"evenodd\" d=\"M19.928 51.837l4.097 4.097 39.988-39.988-7.88-7.88-31.979 31.978L7.867 24.25l-7.88 7.88 19.94 19.707z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol